import { AfterViewInit, Directive, Input } from '@angular/core';
import { LlTabsComponent } from '../ll-tabs-core/ll-tabs.component';

@Directive({
    selector: '[ll-decorated-panel]'
})
export class LlDecoratedPanelDirective implements AfterViewInit {
    @Input() set backgroundColor(value: string) {
        this._backgrounColor = value;
        this.element.tabContainer.nativeElement.style.backgroundColor = value;
    }
    private _backgrounColor = '#f2f2f2';
    constructor (private element: LlTabsComponent) {
    }
    
    ngAfterViewInit(): void {
        this.element.tabContainer.nativeElement.style.backgroundColor = this._backgrounColor;
    }
}